<script setup>
import useDebug from '@/hooks/useDebug';
import { useLoadingStore } from '@/stores/loading';
import { useToast } from 'vue-toastification';

const toast = useToast();
const loadingStore = useLoadingStore();
const props = defineProps({
  params: Object,
});

const { toggleDeleted } = useDebug();

const ACTIVE = "Active";
const DELETED = "Deleted";

const handleClick = async () => {  
  const { bin } = props.params.data;
  if (bin?.holds_destructable_damage || bin?.holds_processable_damage) {
    toast.error("This LP has damaged LPNs and cannot be updated.");
    return;
  }

  loadingStore.state(true);
  try {  
    const response = await toggleDeleted(props.params.data.id, !props.params.data.deleted);
    if (response) {
      props.params.onLpToggled(props.params.data);
      props.params.api.refreshServerSide();
    }
  } finally {
    loadingStore.state(false);
  }
}
</script>

<template>
  <v-btn :disabled="loadingStore.isLoading" @click="handleClick" density="compact" :color="props.params.data.deleted ? 'red' : 'green'">{{props.params.data.deleted ? DELETED : ACTIVE}}</v-btn>
</template>
